// prettier-ignore
export const environment = {
  production: false,
  staging: false,
  urlUi: "https://development.hub.atsinformatica.com.br/",
  urlApiUsuarioAdmin: "https://api.development.hub.atsinformatica.com.br/ats-hub-api-usuario-admin/",
  urlApiSRVLog: "https://api.development.hub.atsinformatica.com.br/ats-hub-api-srvlog/",
  urlApiUsuario: "https://api.development.hub.atsinformatica.com.br/ats-hub-api-usuario/",
  urlApiRelatorioInterno: "https://api.development.hub.atsinformatica.com.br/ats-hub-api-relatorio-interno/",
  urlApiRepositorioTintas: "https://api.development.hub.atsinformatica.com.br/ats-hub-api-repositorio-tintas/",
  urlApiIntegracaoArquivos: "https://api.development.hub.atsinformatica.com.br/ats-hub-api-integracao-arquivos/",
  urlApiSrvNotificacao: "https://api.development.hub.atsinformatica.com.br/ats-hub-api-srvnotificacao/",
  urlApiMotorFiscal: "https://api.development.hub.atsinformatica.com.br/ats-hub-api-motor-fiscal/",
  googleClienteId: "461503592490-l8j6p4vc99vdpaibiq533cccdrghg8ms.apps.googleusercontent.com",
};
